import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (entity) => {
    return (_openBlock(), _createElementBlock("li", {
      key: `overlap_group_${entity.id}`
    }, [
      _createElementVNode("em", null, _toDisplayString(_ctx.entityName) + " " + _toDisplayString(entity.id), 1 /* TEXT */),
      _cache[1] || (_cache[1] = _createTextVNode(" is also attached to the following campaigns: ", -1 /* CACHED */)),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entity.campaigns, (campaign) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `overlap_entity_${entity.id}_campaign_${campaign.id}`
          }, [
            _createElementVNode("span", {
              class: "DetailedSubListLine OverlapDetails",
              title: campaign.name
            }, [
              _cache[0] || (_cache[0] = _createTextVNode(" Campaign ", -1 /* CACHED */)),
              _createElementVNode("a", {
                href: _ctx.constructCampaignEditorLink(campaign.id)
              }, _toDisplayString(campaign.id), 9 /* TEXT, PROPS */, _hoisted_2),
              _createTextVNode(": " + _toDisplayString(campaign.name), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_1)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]))
  }), 128 /* KEYED_FRAGMENT */))
}